import React from "react"
import ItemsList from "./ItemsList"
import "../styles/mainTerminalWindow.scss"

const LsDisplay: React.FC = () => {
  const isBrowser = typeof window !== "undefined"

  return (
    <div className="LsDisplayWindow">
      {isBrowser ? <ItemsList /> : null}
    </div>
  )
}

export default LsDisplay
